// #region JSDoc
/**
 * @typedef {Object} Produto
 * @property {number|null} id
 * @property {string} nome
 * @property {string} marca
 * @property {string} unidade_medida
 * @property {string} descricao
 * @property {number} preco_venda
 * @property {number} estoque_atual
 * @property {number} estoque_min
 * @property {string} validade ISO (YYYY-MM-DD)
 * @property {string} lote
 *
 * Shape da entidade Produto no frontend.
 * Mapeadores/Builders adicionais em produtos-utils.js
 */
// #endregion

// #region Classe Produto
export class Produto {
  constructor({
    id = null,
    nome = '',
    marca = '',
    unidade_medida = '',
    descricao = '',
    preco_venda = 0,
    estoque_atual = 0,
    estoque_min = 0,
    validade = '',
    lote = '',
  }) {
    this.id = id;
    this.nome = nome;
    this.marca = marca;
    this.unidade_medida = unidade_medida;
    this.descricao = descricao;
    this.preco_venda = Number(preco_venda || 0);
    this.estoque_atual = Number(estoque_atual || 0);
    this.estoque_min = Number(estoque_min || 0);
    this.validade = validade;
    this.lote = lote;
  }

  static fromJSON(obj = {}) {
    return new Produto({
      id: obj.id ?? null,
      nome: obj.nome ?? '',
      marca: obj.marca ?? '',
      unidade_medida: obj.unidade_medida ?? '',
      descricao: obj.descricao ?? '',
      preco_venda: obj.preco_venda ?? 0,
      estoque_atual: obj.estoque_atual ?? 0,
      estoque_min: obj.estoque_min ?? 0,
      validade: obj.validade ?? '',
      lote: obj.lote ?? '',
    });
  }

  static fromBackend(dto = {}) {
    return Produto.fromJSON({
      id: dto.id,
      nome: dto.nome,
      marca: dto.marca,
      unidade_medida: dto.unidade_medida || dto.unidadeMedida,
      descricao: dto.descricao,
      preco_venda: dto.preco_venda ?? dto.precoVenda,
      estoque_atual: dto.estoque_atual ?? dto.estoqueAtual,
      estoque_min: dto.estoque_min ?? dto.estoqueMin,
      validade: dto.validade,
      lote: dto.lote,
    });
  }

  toJSON() {
    return {
      id: this.id,
      nome: this.nome,
      marca: this.marca,
      unidade_medida: this.unidade_medida,
      descricao: this.descricao,
      preco_venda: this.preco_venda,
      estoque_atual: this.estoque_atual,
      estoque_min: this.estoque_min,
      validade: this.validade,
      lote: this.lote,
    };
  }

  formattedPreco(locale = 'pt-BR', currency = 'BRL') { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(this.preco_venda || 0); }
  formattedValidade(locale = 'pt-BR') {
    if (!this.validade) return '-';
    try { return new Intl.DateTimeFormat(locale).format(new Date(this.validade)); } catch { return this.validade; }
  }
}
// #endregion
